import StationsPage from './stations-page';

export default StationsPage;